import { Box, Typography } from '@mui/material';
export function DrawCircle({ size = 30, backGround = '#2e7d32', borderColor = '#2e7d32', border = false, image = '', borderWidth = 1, imageWidth = 15, innerImage = true,content="" }) {
   
    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: backGround,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: border ? `${borderWidth}px solid ${borderColor}` : "none"
            }}
            aria-label="success">

            {innerImage ? <img
                src={image}
                alt="Save"
                width={imageWidth}
                height={imageWidth}
                style={{ display: "block" }}
            /> :
                <Typography
                    component="span"
                    sx={{
                        fontWeight: 700,
                        fontSize: 14,color:"#808080"
                    }}

                >
                    {content}
                </Typography>

            }
        </Box>
    );
}

